export * from './app.component';
export * from './app.module';
export * from './app.routing';



// WEBPACK FOOTER //
// /app/src/app/index.ts